import { Box, Flex } from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import {
  ResponsiveCards,
  type ResponsiveCard,
} from "components/responsive-cards";
import { usePropertyTenancy } from "contexts/property-tenancy-provider";
import { tenancyOverviewModel } from "modules/tenant-portal/models/overview";
import { AgencyDetails } from "modules/tenant-portal/screens/overview/components/agency-details";
import { TenantBannerImage } from "modules/tenant-portal/screens/overview/components/banner-image/tenant-banner-image";
import { TenancyDetails } from "modules/tenant-portal/screens/overview/components/tenancy-details";

export function OverviewScreen() {
  const { propertyTenancyId: selectedPropertyTenancy } = usePropertyTenancy();
  const { data, isLoading } = useQuery(
    tenancyOverviewModel.queries.read(selectedPropertyTenancy),
  );

  const tenancy = data?.tenancy;

  const cards: ResponsiveCard[] = [
    {
      label: "Tenancy Details",
      element: <TenancyDetails tenancy={tenancy} />,
    },
    {
      label: "Agency details",
      element: <AgencyDetails agency={data?.agency} />,
    },
  ];

  return (
    <Box p={0}>
      <Flex direction={"column"} gap={8}>
        <TenantBannerImage isLoading={isLoading} data={data} />
        <ResponsiveCards cards={cards} />
      </Flex>
    </Box>
  );
}
